import React from 'react';

const NotFoundPage = () => {
  return (
    <div>
      <p>No found!</p>
    </div>
  );
};

export default NotFoundPage;